import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import NotificationBell from "@components/Notification/NotificationBell";
import Profile from "@features/Profile/Profile";
import { HeaderBranding } from "./HeaderBranding";
import { getInitialSidebarCollapsed } from "@features/CmDashboard/cmAdmin";
import type { RootState } from "@store/store";
import "@components/Sidebar/Sidebar.css";

const Header = React.memo(() => {
	const user = useSelector((state: RootState) => state.user.user);
	const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => getInitialSidebarCollapsed(user));

	useEffect(() => {
		const handleSidebarToggle = (event: CustomEvent<{ isCollapsed: boolean }>) => {
			setIsSidebarCollapsed(event.detail.isCollapsed);
		};

		window.addEventListener("sidebarToggle", handleSidebarToggle as EventListener);
		return () => {
			window.removeEventListener("sidebarToggle", handleSidebarToggle as EventListener);
		};
	}, []);

	return (
		<header
			className={`app-header header-content sticky top-0 z-30 flex items-center justify-between ${
				isSidebarCollapsed ? "header-collapsed" : "header-expanded"
			}`}>
			<HeaderBranding />
			<div className="flex shrink-0 items-center gap-2 sm:gap-3">
				<div className="header-action-circle">
					<NotificationBell />
				</div>
				<Profile />
			</div>
		</header>
	);
});

export default Header;
